module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v-tabs notes-list cash-receipt",
    class: {
      'cash-empty': _vm.tableData.length === 0
    }
  }, [(_vm.tableData.length === 0) ? _c('div', {
    staticClass: "empty"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/imgs/empty.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "text"
  }, [_vm._v("无回款单信息")])]) : _c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "total"
  }, _vm._l((_vm.summaryInfo), function(item) {
    return _c('span', {
      class: [item.attr]
    }, [_vm._v("\n        " + _vm._s(item.attrName) + ": " + _vm._s(item.amount) + " " + _vm._s(_vm.unit) + "\n      ")])
  }))]), _vm._v(" "), (_vm.tableData.length > 0) ? _c('div', {
    ref: "content",
    staticClass: "content"
  }, [_c('ul', {
    staticClass: "item-list"
  }, _vm._l((_vm.tableData), function(item) {
    return _c('li', {
      staticClass: "item",
      class: {
        'hc-red': _vm.isRed || item.isRed
      }
    }, [_c('div', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm.formatTime(item.addTime)))]), _vm._v(" "), _c('div', {
      staticClass: "order"
    }, [_c('div', {
      staticClass: "border"
    }, [(item.isBad) ? _c('div', {
      staticClass: "chapter"
    }, [_c('img', {
      attrs: {
        "src": require("../../../assets/imgs/bad.png")
      }
    })]) : (item.isCancel) ? _c('div', {
      staticClass: "chapter"
    }, [_c('img', {
      attrs: {
        "src": require("../../../assets/imgs/cancel.png")
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "header"
    }, [_c('span', {
      staticClass: "tit"
    }, [_vm._v(_vm._s(item.amount) + " 元")]), _vm._v(" "), _vm._l((item.payMethod), function(payMethod) {
      return _c('span', {
        staticClass: "tag",
        class: payMethod.color
      }, [_vm._v(_vm._s(payMethod.text))])
    })], 2), _vm._v(" "), _c('ul', {
      staticClass: "content"
    }, [_c('li', {
      staticClass: "item"
    }, [_c('span', {
      staticClass: "left"
    }, [_vm._v("回款单编号:")]), _vm._v(" "), _c('span', {
      staticClass: "right"
    }, [_vm._v(_vm._s(item.paymentSheetNo))])]), _vm._v(" "), _c('li', {
      staticClass: "item"
    }, [_c('span', {
      staticClass: "left"
    }, [_vm._v("归属人:")]), _vm._v(" "), _c('span', {
      staticClass: "right"
    }, [_vm._v(_vm._s(item.belongerName))])]), _vm._v(" "), _c('li', {
      staticClass: "item"
    }, [_c('span', {
      staticClass: "left"
    }, [_vm._v("实际回款日期:")]), _vm._v(" "), _c('span', {
      staticClass: "right"
    }, [_vm._v(_vm._s(item.paymentTime))])]), _vm._v(" "), _c('li', {
      staticClass: "item"
    }, [_c('span', {
      staticClass: "left"
    }, [_vm._v("备注:")]), _vm._v(" "), _c('span', {
      staticClass: "right"
    }, [_vm._v(_vm._s(item.memo))])]), _vm._v(" "), (item.file && item.file.length) ? _c('li', {
      staticClass: "item"
    }, [_c('span', {
      staticClass: "left"
    }, [_vm._v("文件:")]), _vm._v(" "), _c('span', {
      staticClass: "right"
    }, [_c('attachment-preview', {
      attrs: {
        "data": item.file
      }
    })], 1)]) : _vm._e()])]), _vm._v(" "), _c('el-button', {
      staticClass: "delete",
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          _vm.deleteCash(item.id)
        }
      }
    }, [_vm._v("删除")])], 1)])
  }))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12861ac8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/payment/cash-receipt.vue
// module id = 1217
// module chunks = 82